import script from "./CreateAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAddress.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAddress.vue?vue&type=style&index=0&id=6b2ba0a7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2ba0a7"]])

export default __exports__